var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.796 0.243989C9.653 -0.174011 11 1.42199 11 2.99999V17C11 18.578 9.653 20.174 7.796 19.756C3.334 18.752 0 14.766 0 9.99999C0 5.23399 3.334 1.24799 7.796 0.243989ZM13.293 6.29299C13.4805 6.10552 13.7348 6.0002 14 6.0002C14.2652 6.0002 14.5195 6.10552 14.707 6.29299L17.707 9.29299C17.8945 9.48052 17.9998 9.73483 17.9998 9.99999C17.9998 10.2652 17.8945 10.5195 17.707 10.707L14.707 13.707C14.5184 13.8891 14.2658 13.9899 14.0036 13.9877C13.7414 13.9854 13.4906 13.8802 13.3052 13.6948C13.1198 13.5094 13.0146 13.2586 13.0123 12.9964C13.01 12.7342 13.1108 12.4816 13.293 12.293L14.586 11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 9.99999C5 9.73477 5.10536 9.48042 5.29289 9.29288C5.48043 9.10535 5.73478 8.99999 6 8.99999H14.586L13.293 7.70699C13.1055 7.51946 13.0002 7.26515 13.0002 6.99999C13.0002 6.73482 13.1055 6.48052 13.293 6.29299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon2);
export default __webpack_public_path__ + "static/media/logout-icon2.e2e7c8f1f511d7f470c901981522c02d.svg";
export { ForwardRef as ReactComponent };